import { Badge } from '@/components/ui/badge'

interface InvoiceStatusBadgeProps {
  isSuperseded?: boolean
  supersededByInvoiceId?: string | null
  supersededAt?: string | null
}

/**
 * Badge "REMPLACÉE" displayed on every surface listing invoices when the
 * invoice has been superseded by a Mode A credit note. SOLY-CN-001 mini-scope 04.
 *
 * Renders nothing when the invoice is not superseded — safe to drop into any
 * row template without conditional wrappers at the call site.
 */
export function InvoiceStatusBadge({
  isSuperseded,
  supersededByInvoiceId,
  supersededAt,
}: InvoiceStatusBadgeProps) {
  if (!isSuperseded) return null

  const tooltipText = supersededByInvoiceId
    ? `Remplacée par la note de crédit ${supersededByInvoiceId.slice(0, 8)}…${
        supersededAt ? ` le ${new Date(supersededAt).toLocaleDateString('fr-BE')}` : ''
      }`
    : 'Remplacée par une note de crédit'

  return (
    <Badge
      variant="secondary"
      data-testid="invoice-status-badge-superseded"
      className="ml-2 text-xs"
      title={tooltipText}
      aria-label={tooltipText}
    >
      REMPLACÉE
    </Badge>
  )
}
